import React from 'react'

const FormatorMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_4949_40937)"
      fillOpacity="0.1"
    />
    <path
      d="M19.7979 12.0609C19.7388 13.5976 19.1182 14.8093 17.7884 15.6072C16.1039 16.612 14.0057 16.1391 12.8236 14.5138C11.5233 12.7111 11.8779 10.1105 13.6215 8.78063C15.6902 7.21437 18.6158 8.10094 19.5319 10.5833C19.7092 11.0266 19.7979 11.529 19.7979 12.0609Z"
      fill="#052351"
    />
    <path
      d="M23.6396 20.8674C23.3737 19.7149 22.7235 18.8283 21.8074 18.119C20.7731 17.2916 19.591 16.7892 18.3498 16.4346C18.0838 16.3459 17.877 16.3755 17.6701 16.5823C17.1382 17.0552 16.5471 17.4689 15.9856 17.9122C15.9561 17.8826 15.9265 17.8531 15.897 17.8531C15.3059 17.3802 14.7444 16.937 14.1534 16.4641C14.0943 16.405 13.9761 16.3755 13.917 16.405C12.6758 16.7005 11.4937 17.2029 10.4594 17.9417C10.1047 18.2077 9.75012 18.5328 9.3955 18.8283C9.18863 19.0056 9.18863 19.0647 9.09998 19.1534C9.95699 18.9465 11.1982 19.3307 11.5824 20.3059C11.7597 20.8083 11.7597 21.3402 11.5233 21.8426C11.2277 22.4337 10.7253 22.8178 10.0456 22.9656C11.1686 23.4384 12.2916 23.7044 13.4737 23.8522V19.0943C14.0056 19.1534 14.4785 19.2125 14.9809 19.2716C15.8379 19.4193 16.6949 19.6853 17.4632 20.1286C17.5519 20.1877 17.611 20.2468 17.611 20.365C17.611 21.5175 17.611 22.6701 17.6406 23.7931C17.6406 23.8522 17.6406 23.9408 17.6406 23.9999H18.1429C18.1429 23.9408 18.1429 23.8817 18.1429 23.8522C18.1429 22.8769 18.1134 21.9017 18.1134 20.897C18.1134 20.6605 18.0543 20.365 18.1725 20.1877C18.2907 20.0104 18.5862 19.9217 18.8226 19.8035C19.6501 19.4193 20.5367 19.242 21.4232 19.1238C21.6892 19.0943 21.9552 19.0943 22.2507 19.0647V20.4832C22.9304 20.631 23.4032 21.0447 23.7283 21.6949C23.7578 21.6062 23.7874 21.5767 23.7874 21.5175C23.6692 21.3402 23.6692 21.1038 23.6396 20.8674Z"
      fill="#052351"
    />
    <path
      d="M23.3147 22.5223C23.2852 23.3202 22.6055 23.9704 21.8075 23.9704C20.9801 23.9408 20.3299 23.2611 20.3595 22.4337C20.389 21.6357 21.0687 20.9856 21.8667 20.9856C22.6646 20.9856 23.3147 21.6948 23.3147 22.5223Z"
      fill="#052351"
    />
    <path
      d="M9.632 19.5081C10.489 19.5081 11.1687 20.1582 11.1687 20.9857C11.1687 21.8131 10.489 22.4633 9.66155 22.4633C8.83409 22.4633 8.18394 21.754 8.21349 20.9266C8.24305 20.0991 8.86364 19.5376 9.632 19.5081Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4949_40937"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default FormatorMenu
